import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private appConfig: any;

  constructor(private http: HttpClient) {
  }

  public async loadAppConfig() {
    return await this.getAPIURL();
  }
  public setConfig(config: any) {
    this.appConfig = config;
  }

  public getConfig() {
    return this.appConfig;
  }

  private async getAPIURL() {
    if (!this.appConfig) {
      const data: any = await this.http.get('/assets/config.json').toPromise();;
      this.appConfig = data;
      }
  }
}